'use es6';

import * as DataTypes from '../../constants/dataTypes';
import * as UnifiedDataTypes from '../../constants/dataTypes/unified';
export const utc = [DataTypes.TEMPLATES];
export const sunday = Object.keys(UnifiedDataTypes);
export const get = dataType => ({
  utc: utc.includes(dataType) || false,
  sunday: sunday.includes(dataType) || false
});